module.exports = new __parcel__URL__("buoy-local-logo-empowering.a1bc7cd4.png").toString();